<template>
  <div>
    <Login></Login>
  </div>
</template>

<script>
import Login from "@/components/shoplus_service/partners/Login.vue";

export default {
  components: {
    Login,
  },
  data: () => ({
    //
  }),
};
</script>
